import { render, staticRenderFns } from "./SalariePrintCompensation.vue?vue&type=template&id=b2000bb0&scoped=true"
import script from "./SalariePrintCompensation.vue?vue&type=script&lang=js"
export * from "./SalariePrintCompensation.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintCompensation.vue?vue&type=style&index=0&id=b2000bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2000bb0",
  null
  
)

export default component.exports